import script from "./ContractSupportItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractSupportItem.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/ContractSupportItem.css?vue&type=style&index=0&id=01f7e6c4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f7e6c4"]])

export default __exports__